import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useJamaah } from "@/context/JamaahContext";
import { jamaahApi } from "@/lib/jamaahApi";
import { errMsg } from "@/lib/api";
import { JamaahFields, Field } from "./JamaahFields";
import { AvatarField } from "./AvatarField";

export const ProfilSaya = () => {
  const { jamaah, setJamaah } = useJamaah();
  const [form, setForm] = useState({ name: jamaah.name, gender: jamaah.gender, rt: jamaah.rt, rw: jamaah.rw, address: jamaah.address, notes: jamaah.notes });
  const [pw, setPw] = useState({ old_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const [savingPw, setSavingPw] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const saveProfile = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await jamaahApi.put("/jamaah/me", form);
      setJamaah(data);
      toast.success("Profil berhasil diperbarui");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  const savePassword = async (e) => {
    e.preventDefault();
    if (pw.new_password !== pw.confirm) return toast.error("Konfirmasi kata sandi tidak sama");
    setSavingPw(true);
    try {
      await jamaahApi.post("/jamaah/me/password", { old_password: pw.old_password, new_password: pw.new_password });
      setPw({ old_password: "", new_password: "", confirm: "" });
      toast.success("Kata sandi berhasil diganti");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSavingPw(false);
    }
  };

  return (
    <div className="grid lg:grid-cols-5 gap-6" data-testid="portal-profil">
      <form onSubmit={saveProfile} className="lg:col-span-3 rounded-2xl border border-emerald-900/10 bg-white p-6 space-y-4">
        <h3 className="font-bold text-emerald-950">Data Diri</h3>
        <AvatarField />
        <Field id="profil-phone" label="No. HP / WA (username)">
          <Input id="profil-phone" value={jamaah.phone} disabled data-testid="profil-phone-display" />
        </Field>
        <JamaahFields form={form} set={set} prefix="profil" showPhone={false} />
        <Button type="submit" className="rounded-full emerald-bg hover:bg-[#145c48]" disabled={saving} data-testid="profil-save-btn">
          {saving ? <Loader2 className="animate-spin" size={16} /> : "Simpan Perubahan"}
        </Button>
      </form>
      <form onSubmit={savePassword} className="lg:col-span-2 rounded-2xl border border-emerald-900/10 bg-white p-6 space-y-4 self-start">
        <h3 className="font-bold text-emerald-950">Ganti Kata Sandi</h3>
        <Field id="pw-old" label="Kata Sandi Lama" required>
          <Input id="pw-old" type="password" value={pw.old_password} onChange={(e) => setPw({ ...pw, old_password: e.target.value })} required data-testid="pw-old-input" />
        </Field>
        <Field id="pw-new" label="Kata Sandi Baru" required>
          <Input id="pw-new" type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} required minLength={6} data-testid="pw-new-input" />
        </Field>
        <Field id="pw-confirm" label="Konfirmasi Kata Sandi Baru" required>
          <Input id="pw-confirm" type="password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} required data-testid="pw-confirm-input" />
        </Field>
        <Button type="submit" variant="outline" className="rounded-full" disabled={savingPw} data-testid="pw-save-btn">
          {savingPw ? <Loader2 className="animate-spin" size={16} /> : "Ganti Kata Sandi"}
        </Button>
      </form>
    </div>
  );
};
